// src/components/ui/BundleBadge/BundleBadge.jsx
import React from 'react';
import { Package } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './BundleBadge.module.css';

const BundleBadge = ({ className = '', size, variant = 'compact' }) => {
  const { t } = useLocalization();
  const isList = variant === 'list';
  return (
    <span className={`${styles.bundleBadge} ${isList ? styles.list : ''} ${className}`}>
      <Package size={size ?? (isList ? 14 : 12)} />
      {t('products.bundleProductShort')}
    </span>
  );
};

export default BundleBadge;
